export enum RolesEnum {
  ADMIN = 'admin',
  COORDINATOR = 'coordinator',
  ADVISER = 'adviser'
}
